import React, { useEffect, useState } from 'react';
import { Table, Badge, Button, Alert, Spinner } from 'react-bootstrap';
import ContaServicoViewModel, { ContaServico } from '../../viewmodel/ContaServicoViewModel';
import OptOutEmailModal from './components/OptOutEmailModal';
import { useBreadcrumbs } from '../../Routes/BreadcrumbContext';

const MinhasContasServicoPage: React.FC = () => {
    const { setBreadcrumbs } = useBreadcrumbs();
    const [contas, setContas] = useState<ContaServico[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [contaOptOut, setContaOptOut] = useState<ContaServico | null>(null);

    useEffect(() => {
        setBreadcrumbs([
            { path: '/', breadcrumb: '🏠' },
            { path: '/contas-servico/minhas', breadcrumb: 'Minhas Contas de Serviço' },
        ]);
    }, []);

    useEffect(() => {
        const fetchContas = async () => {
            try {
                setLoading(true);
                const resultado = await ContaServicoViewModel.getMinhasContasServico(0, 100);
                setContas(resultado.content);
            } catch (e) {
                setError(e instanceof Error ? e.message : 'Erro ao carregar contas');
            } finally {
                setLoading(false);
            }
        };
        fetchContas();
    }, []);

    if (loading) return <Spinner animation="border" className="m-4" />;
    if (error) return <Alert variant="danger" className="m-4">{error}</Alert>;

    return (
        <div className="container mt-4">
            <h2>Minhas Contas de Serviço</h2>
            <hr />
            {contas.length === 0 ? (
                <Alert variant="info">Você não possui contas de serviço como responsável.</Alert>
            ) : (
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Descrição</th>
                            <th>Status</th>
                            <th>E-mail Banca Aberta</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {contas.map((conta) => (
                            <tr key={conta.clientId}>
                                <td>{conta.descricao}</td>
                                <td>
                                    <Badge bg={conta.status === 'ATIVA' ? 'success' : conta.status === 'APROVADO' ? 'warning' : 'secondary'}>
                                        {conta.status}
                                    </Badge>
                                </td>
                                <td>
                                    {conta.optOutEmailIntegracaoBancaAberta
                                        ? <Badge bg="warning" text="dark">🔕 Silenciado</Badge>
                                        : <Badge bg="success">🔔 Ativo</Badge>
                                    }
                                </td>
                                <td>
                                    <Button size="sm" variant="outline-secondary" onClick={() => setContaOptOut(conta)}>
                                        Preferências de E-mail
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}

            {contaOptOut && (
                <OptOutEmailModal
                    show={true}
                    conta={contaOptOut}
                    onClose={() => setContaOptOut(null)}
                    onSuccess={(atualizada) => {
                        setContas(prev => prev.map(c => c.clientId === atualizada.clientId ? atualizada : c));
                        setContaOptOut(null);
                    }}
                />
            )}
        </div>
    );
};

export default MinhasContasServicoPage;
